import { FC } from 'react'
import styled from 'styled-components'
import { colors } from '../components'
import { ReactComponent as FilterCloseIcon } from '../images/icons_2023/check.svg'
// import { ReactComponent as FilterIcon } from '../images/icons_2023/filtern.svg'
import { ReactComponent as FilterIcon } from '../images/filter-btn.svg'

const MenuButtonBase = styled.div<{ $isOpen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease-out, visibility 0.2s ease-out;
  width: 56px;
  height: 56px;
  z-index: 10;
  img {
    width: 56px;
    height: 56px;
  }

  svg {
    width: 56px;
    height: 56px;

    circle,
    .bg {
      fill: ${(props) =>
        props.$isOpen
          ? colors.Button.backgroundOpen
          : colors.Button.background};
    }

    path,
    .content {
      fill: ${colors.Button.text};
    }
  }
  pointer-events: auto;
`

type Props = {
  onClick?: () => void
  isOpen?: boolean
}

export const FilterButton: FC<Props> = ({ isOpen, onClick }) => {
  return (
    <>
      <MenuButtonBase onClick={onClick} $isOpen={isOpen}>
        {isOpen ? <FilterCloseIcon /> : <FilterIcon />}
      </MenuButtonBase>
    </>
  )
}
